"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("./store");
Object.defineProperty(exports, "StoreContextProvider", { enumerable: true, get: function () { return store_1.StoreContextProvider; } });
__exportStar(require("./api-clients"), exports);
__exportStar(require("./connector"), exports);
__exportStar(require("./listing-context"), exports);
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "useMemoizedObject", { enumerable: true, get: function () { return hooks_1.useMemoizedObject; } });
var Messages_1 = require("../codegen/Messages");
Object.defineProperty(exports, "setConnectorLanguage", { enumerable: true, get: function () { return Messages_1.changeLanguage; } });
/**
 * Initialize Loom i18n plugin to default of "en", and provide configuration hook
 */
var Messages_2 = require("../codegen/Messages");
try {
    // If the optional oui-react dependency is satisfied, hook into the oui config provider
    var OuiConfiguration = require("oui-react").OuiConfiguration;
    OuiConfiguration.registerChangeLanguageCallback(Messages_2.changeLanguage);
    OuiConfiguration.registerInitLanguageCallback(Messages_2.init);
}
catch (e) {
    console.debug("oui-react optional dependency not satisfied, using 'en'");
    Messages_2.init("en");
}
//# sourceMappingURL=index.js.map